import { useState } from "react";
import { evaluate } from "mathjs";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

const buttons = [
  ["Rad", "Deg", "(", ")", "%", "DEL", "AC"],
  ["Inv", "sin", "ln", "7", "8", "9", "÷"],
  ["π", "cos", "log", "4", "5", "6", "×"],
  ["e", "tan", "√", "1", "2", "3", "−"],
  ["Ans", "EXP", "^", "0", ".", "=", "+"],
];

const ScientificCalculator = () => {
  const [expression, setExpression] = useState("");
  const [result, setResult] = useState("");
  const [lastAns, setLastAns] = useState("");

  const replaceSymbols = (expr) =>
    expr
      .replace(/÷/g, "/")
      .replace(/×/g, "*")
      .replace(/−/g, "-")
      .replace(/π/g, "pi")
      .replace(/√/g, "sqrt")
      .replace(/EXP/g, "e^")
      .replace(/Ans/g, lastAns)
      .replace(/log/g, "log10");

  const handleClick = (value) => {
    if (value === "AC") {
      setExpression("");
      setResult("");
      return;
    }

     if (value === "DEL") {
      setExpression((prev) => prev.slice(0, -1));
      return;
    }


    if (value === "=") {
      try {
        const cleanExpr = replaceSymbols(expression);
        const evalResult = evaluate(cleanExpr);
        setResult(evalResult);
        setLastAns(evalResult);
      } catch (err) {
        setResult("Error");
      }
      return;
    }
    

    if (["sin", "cos", "tan", "log", "ln", "sqrt"].includes(value)) {
      setExpression((prev) => prev + `${value}(`);
    } else {
      setExpression((prev) => prev + value);
    }
  };

  return (
    <>
     <Helmet>
        <title>Advanced Scientific Calculator - Free Online Tool</title>
        <meta
          name="description"
          content="Free online scientific calculator with advanced math, trig, and log functions. Future-proof tool for students, professionals, and scientists."
        />
        <meta
          name="keywords"
          content="scientific calculator, online calculator, math calculator, trig calculator, logarithmic calculator, google calculator alternative"
        />
        <link rel="canonical" href="https://freelity.com/calculator" />
      </Helmet>
      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Advanced Scientific Calculator</h2>
          <div className="maincalculator">
            <div className="mb-2">
              <input
                type="text"
                className="form-control mb-1 text-end"
                value={expression}
                placeholder="Enter calculation"
                readOnly
              />
              <input
                type="text"
                 placeholder="Total amount"
                className="form-control text-end bg-white fw-bold "
                value={result}
                readOnly
              />
            </div>

            <div className="calculator-box">
              {buttons.map((row, rowIndex) => (
                <div className="calculator-btn" key={rowIndex}>
                  {row.map((btn) => {
                    let btnClass = "btn btn-outline-primary"; 
                    if (btn === "AC") btnClass = "btn btn-danger";        
                    else if (btn === "DEL") btnClass = "btn btn-warning"; 

                    return (
                      <button
                        key={btn}
                        className={btnClass}
                        onClick={() => handleClick(btn)}
                      >
                        {btn}
                      </button>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      </>
  );
};

export default ScientificCalculator;
